module.exports = __webpack_public_path__ + "img/add-file.66d50d6d.svg";